<template>
  <div>
    <div class="header">
      <div class="container">
        <div class="row">
          <div class="col-8">
            <a
              href="#"
              class="content-toggler"
              @click.stop.prevent="showTableContents"
            >
              <i class="fas fa-bars"></i>
            </a>
            <!-- <a href="#" v-if="$route.name!='Home'" @click.stop.prevent="showTableContents" class="content-toggler" >Table of Contents</a> -->
            <a href="https://d364xagvl9owmk.cloudfront.net/media-10-4-18/media/filer_public/12/a2/12a26009-d8a9-4d6c-b30a-2177edcaafa6/zain_2021tlr_arabic.pdf" target="_blank" class="download-btn" v-show="this.$i18n.locale=='ar'">
              <i class="fa fa-download"></i>  {{$t('reportVersion.version')}}
            </a>
            <a href="https://d364xagvl9owmk.cloudfront.net/media-10-4-18/media/filer_public/ab/2e/ab2ee2f0-9ffd-4e56-ba3e-014b61babf5b/zain_2021tlr_english.pdf" target="_blank" class="download-btn" v-show="this.$i18n.locale=='en'">
              <i class="fa fa-download"></i>  {{$t('reportVersion.version')}}
            </a>
          </div>
          <div class="col-4 text-right">
            <!-- <a href="#" class="lang-btn ar">العربية</a> -->
            <a href="#" @click.prevent="changeLocale(otherLocale)" class="lang-btn ar">{{ otherLangText }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      homePage: false 
    };
  },
  methods: {
    showTableContents() {
      document.body.parentNode.classList.add('overflow-hidden')
      document.body.classList.add("isVisible");
    },
    changeLocale(locale) {
        // localStorage.language = locale
        this.$i18n.locale = locale
        console.log(locale);
        this.$router.push({
            params: {lang: locale}
        })
        this.$router.go()
    },
  },
  computed:{

    otherLangText() {
        
        return this.$i18n.locale === 'ar' ? 'English' : 'العربية'
    },
    otherLocale() {
        return this.$i18n.locale === 'en' ? 'ar' : 'en'
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: none;
  background: #000;
  padding: 15px 0;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  height: 50px;
  @media screen and (max-width: 991px) {
    display: block;
  }
}
.header .row {
  align-items: center;
}
.header .content-toggler {
  width: auto;
  font-size: 20px;
  padding: 0;
  position: relative;
  display: inline-block;
  margin: 0;
  left: 0;
  top: 0;
  transform: none;
  vertical-align: middle;
  margin: 0 10px 0 0;
  border-radius: 0;
  background: transparent;
}
.header .download-btn {
  padding: 0;
  border: 0;
  font-size: 16px;
  background: transparent;
}
.download-btn .fa {
  line-height: 0;
  line-height: 0.8;
  display: table-cell;
  vertical-align: middle;
  padding-right: 5px;
}
.header .lang-btn.ar {
  font-family: "qt_zain_bold";
  font-size: 18px;
  color: #ffffff;
  text-decoration: none;
}
.ar .header .lang-btn.ar {
  font-family: 'Nunito Sans', sans-serif;
}
.ar .header .download-btn{
  font-family: "qt_zain_bold";
}

@media screen and (min-width: 1025px) {
  .header .lang-btn:hover {
    color: rgb(245, 235, 0);
  }
}
@media screen and (max-width: 575px) {
  .header .download-btn {
    font-size: 13px;
  }
  .header .lang-btn {
    font-size: 16px;
  }
}
@media screen and (max-width: 350px) {
  .header .download-btn {
    font-size: 12px;
  }
  .header .lang-btn {
    font-size: 14px;
  }
}



// ar style

.ar {
  .header {
    right: 0;
    left: auto;
    @media screen and (max-width: 991px) {
      display: block;
    }
  }

  .header .content-toggler {
    right: 0;
    left: auto;
    margin: 0 0 0 10px;
  }

  .download-btn .fa {
    padding-left: 5px;
    padding-right:0;
  }
}
</style>
